export default "__VITE_ASSET__mb6hcyzU__"